import React from 'react'
// hooks
import { useShowModal } from 'hooks/index'
// components
import { ReduxSelect, TagMultiValueLabel } from 'components/FormElements'
// constants
import { Modals } from 'constants/index'
// types
import { IField } from 'types/graphql'
import { IOption } from 'components/FormElements/Select'
import { ReduxSelectProps } from 'components/FormElements/ReduxForm/ReduxSelect'
import { WrappedFieldInputProps } from 'redux-form/lib/Field'
// utils
import { cloneDeep } from 'lodash/fp'

interface Props extends ReduxSelectProps {
  field: IField
  required?: boolean
  isDisabled?: boolean
}

export type CreatableSelectOptionClick = ({
  data,
  onChange,
  selectValue
}: {
  data: any
  onChange: WrappedFieldInputProps['onChange']
  selectValue: IOption[]
}) => void

const CreatableSelect: React.FC<Props> = ({ field, isDisabled, validate, required }) => {
  const { showModal } = useShowModal({ modalType: Modals.SELECT_MULTI_VALUE_MODAL })

  const onOptionClick: CreatableSelectOptionClick = ({ data, onChange, selectValue }) => {
    const safeState = cloneDeep(selectValue || [])

    showModal({
      item: data,
      description: data.description,
      handleFormSubmit: (hideModal: () => void) => (formValues: Record<string, any>) => {
        const newInputValue = safeState.map((option) => {
          if (data.value === option.value) {
            return {
              ...option,
              label: formValues.title,
              value: formValues.title,
              description: formValues.description
            }
          }

          return option
        })

        onChange(newInputValue)
        hideModal()
      }
    })
  }

  const createOption = (label: string) => ({
    label,
    value: label,
    description: ''
  })

  return (
    <ReduxSelect
      isMultiple
      isCreatable
      name={field.name}
      label={field.label}
      validate={validate}
      required={required}
      isDisabled={isDisabled}
      openMenuOnClick={false}
      createOption={createOption}
      placeholder={'+ Add value'}
      onOptionClick={onOptionClick}
      components={{
        MultiValueLabel: TagMultiValueLabel
      }}
    />
  )
}

export default CreatableSelect
